export const generatedCustomerDecisionDossierLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-customer-decision-dossier-ledger",
  "operatingRule": "Customer decision dossiers summarize what a buyer can safely review, what the current model suggests, what could change the answer, and which proof gates remain blocked. They are product evidence, not legal clearance, mission design, investment advice, or verified resource claims.",
  "scenarioCount": 6,
  "paidBetaDossierCount": 1,
  "blockedDossierCount": 6,
  "customerReviewReadyCount": 0,
  "commercialUseAllowed": false,
  "customerUseAllowed": false,
  "topScenarioId": "moon-first",
  "evidenceHashes": {
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
    "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
    "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
    "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
  },
  "dossiers": [
    {
      "id": "customer-dossier-moon-first",
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "rank": 1,
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "customerUseState": "paid-beta-internal-diligence",
      "commercialUseAllowed": false,
      "buyerUseBoundary": "Use for internal paid-beta diligence, prioritization, and evidence planning; not cleared for commercial recommendations or redistributed source claims.",
      "decisionLane": "lane-2-conditional-diligence",
      "promotionState": "blocked-for-commercial-proof",
      "summary": "Fastest learning loop and lowest communications burden.",
      "metrics": {
        "deterministicUtility": 67.12,
        "decisionReadinessScore": 62.91,
        "utilityP10": 65.24,
        "utilityMedian": 67.03,
        "utilityP90": 68.88,
        "winProbability": 74.61,
        "uncertaintyBudgetPoints": 29.81,
        "uncertaintyClass": "managed-beta-uncertainty",
        "businessReadinessMedian": 76.65,
        "medianCapitalGapBn": 0
      },
      "evidenceState": {
        "supportingClaimCount": 3,
        "blockedClaimCount": 3,
        "sourceUseCustomerAllowed": false,
        "promotedRuntimeContracts": 2,
        "readyRuntimeContracts": 0,
        "blockedRuntimeContracts": 3,
        "modelRunComparisonCount": 2,
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "supportingClaims": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
        }
      ],
      "blockedClaims": [
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "blockerCount": 2,
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "blockerCount": 3,
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "blockerCount": 3,
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
        }
      ],
      "runRefs": [
        {
          "id": "run-conservative-moon-first-2026-06-19",
          "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
          "selectedUtility": 67.12,
          "claimState": "model-derived-unvalidated"
        }
      ],
      "modelRunComparisons": [
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ],
      "proofToChangeAnswer": {
        "crossoverId": "crossover-hybrid-over-moon-first",
        "challengerScenarioId": "hybrid",
        "currentLeaderScenarioId": "moon-first",
        "requiredUtilityDelta": 1.43,
        "crossoverState": "mathematically-reachable-not-validated",
        "topLeverPaths": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "currentValue": 12,
            "direction": "decrease",
            "utilityPerPoint": 0.42,
            "requiredRawDelta": 3.4,
            "feasibleByRawRange": true,
            "headroom": 12
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "currentValue": 46,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 10.38,
            "feasibleByRawRange": true,
            "headroom": 46
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "currentValue": 55,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 10.38,
            "feasibleByRawRange": true,
            "headroom": 55
          }
        ],
        "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
      },
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 7.99,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "contributionHash": "sha256-e7a820a5533b534b98eb2282a217d51581e38dab0711cf9ec220ba7993bab383"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 6.5,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 6.44,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "contributionHash": "sha256-27860bb055c03086a261c1eb072bb63d5c7b6df40ac68d67afe85cc9d2f71730"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        }
      ],
      "topEvidenceGaps": [
        {
          "id": "gap-runtime-orekit-propagation-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
        },
        {
          "id": "gap-runtime-gmat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
        },
        {
          "id": "gap-runtime-tudat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
        },
        {
          "id": "gap-materials-process-oxygen-isru",
          "category": "materials-process",
          "priorityLane": "P1-business-grade",
          "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
        }
      ],
      "blockers": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
        "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "source-use-rights: Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Customer-facing use remains blocked until source-use review approves cited sources.",
        "3 runtime sidecar contract(s) still block mission-design promotion."
      ],
      "nextProofActions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
      },
      "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573"
    },
    {
      "id": "customer-dossier-hybrid",
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "rank": 2,
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "customerUseState": "research-backlog-only",
      "commercialUseAllowed": false,
      "buyerUseBoundary": "Use only as research backlog intelligence until scenario evidence, runtime validation, and source-use gates improve.",
      "decisionLane": "lane-3-watchlist",
      "promotionState": "blocked-for-commercial-proof",
      "summary": "Bootstrap close, screen feedstock, then scale toward Mercury energy advantage.",
      "metrics": {
        "deterministicUtility": 65.69,
        "decisionReadinessScore": 59.78,
        "utilityP10": 63.32,
        "utilityMedian": 65.48,
        "utilityP90": 67.6,
        "winProbability": 25.39,
        "uncertaintyBudgetPoints": 43.88,
        "uncertaintyClass": "medium-uncertainty",
        "businessReadinessMedian": 72.59,
        "medianCapitalGapBn": 0
      },
      "evidenceState": {
        "supportingClaimCount": 3,
        "blockedClaimCount": 3,
        "sourceUseCustomerAllowed": false,
        "promotedRuntimeContracts": 2,
        "readyRuntimeContracts": 0,
        "blockedRuntimeContracts": 3,
        "modelRunComparisonCount": 2,
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "supportingClaims": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
        }
      ],
      "blockedClaims": [
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "blockerCount": 2,
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "blockerCount": 3,
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "blockerCount": 3,
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
        }
      ],
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "selectedUtility": 65.69,
          "claimState": "model-derived-unvalidated"
        }
      ],
      "modelRunComparisons": [
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ],
      "proofToChangeAnswer": {
        "crossoverId": "crossover-hybrid-over-moon-first",
        "challengerScenarioId": "hybrid",
        "currentLeaderScenarioId": "moon-first",
        "requiredUtilityDelta": 1.43,
        "crossoverState": "mathematically-reachable-not-validated",
        "topLeverPaths": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "currentValue": 12,
            "direction": "decrease",
            "utilityPerPoint": 0.42,
            "requiredRawDelta": 3.4,
            "feasibleByRawRange": true,
            "headroom": 12
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "currentValue": 46,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 10.38,
            "feasibleByRawRange": true,
            "headroom": 46
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "currentValue": 55,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 10.38,
            "feasibleByRawRange": true,
            "headroom": 55
          }
        ],
        "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
      },
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 10.68,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "contributionHash": "sha256-1113356c45a9d66efb46dd79ad7e995ce35753fd92106e8a62a123e46e0c609a"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 9.66,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "contributionHash": "sha256-4e70a0f224a6884c44ccdf9a653d574034fb8de4a78ea8dafb4b627c42b51d72"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 9.5,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "contributionHash": "sha256-07a08f8b629617090c595a9abaae19c858d1033775537f967bec618d3b525523"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 6.5,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
        }
      ],
      "topEvidenceGaps": [
        {
          "id": "gap-runtime-orekit-propagation-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
        },
        {
          "id": "gap-runtime-gmat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
        },
        {
          "id": "gap-runtime-tudat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
        },
        {
          "id": "gap-materials-process-oxygen-isru",
          "category": "materials-process",
          "priorityLane": "P1-business-grade",
          "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
        }
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "resource-evidence: Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Customer-facing use remains blocked until source-use review approves cited sources.",
        "3 runtime sidecar contract(s) still block mission-design promotion."
      ],
      "nextProofActions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
      },
      "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
    },
    {
      "id": "customer-dossier-asteroid-first",
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "rank": 3,
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "customerUseState": "research-backlog-only",
      "commercialUseAllowed": false,
      "buyerUseBoundary": "Use only as research backlog intelligence until scenario evidence, runtime validation, and source-use gates improve.",
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "summary": "Potential materials bank, but composition and operations are object-specific.",
      "metrics": {
        "deterministicUtility": 51.37,
        "decisionReadinessScore": 41.63,
        "utilityP10": 48.31,
        "utilityMedian": 51.44,
        "utilityP90": 54.65,
        "winProbability": 0,
        "uncertaintyBudgetPoints": 62.38,
        "uncertaintyClass": "high-uncertainty",
        "businessReadinessMedian": 59.76,
        "medianCapitalGapBn": 0
      },
      "evidenceState": {
        "supportingClaimCount": 3,
        "blockedClaimCount": 3,
        "sourceUseCustomerAllowed": false,
        "promotedRuntimeContracts": 2,
        "readyRuntimeContracts": 0,
        "blockedRuntimeContracts": 3,
        "modelRunComparisonCount": 2,
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "supportingClaims": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
        }
      ],
      "blockedClaims": [
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "blockerCount": 2,
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "blockerCount": 3,
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "blockerCount": 3,
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
        }
      ],
      "runRefs": [
        {
          "id": "run-asteroid-feedstock-probe-2026-06-19",
          "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
          "selectedUtility": 51.37,
          "claimState": "model-derived-unvalidated"
        }
      ],
      "modelRunComparisons": [
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ],
      "proofToChangeAnswer": {
        "crossoverId": "crossover-asteroid-first-over-moon-first",
        "challengerScenarioId": "asteroid-first",
        "currentLeaderScenarioId": "moon-first",
        "requiredUtilityDelta": 15.75,
        "crossoverState": "outside-single-lever-range",
        "topLeverPaths": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "currentValue": 18,
            "direction": "decrease",
            "utilityPerPoint": 0.42,
            "requiredRawDelta": 37.5,
            "feasibleByRawRange": false,
            "headroom": 18
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "currentValue": 58,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 114.31,
            "feasibleByRawRange": false,
            "headroom": 58
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "currentValue": 72,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 114.31,
            "feasibleByRawRange": false,
            "headroom": 72
          }
        ],
        "crossoverHash": "sha256-14d2ba998f0843e1cdd3b05e6b5d598c9fb1800b385852c58702ed5ca16e6451"
      },
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 15.7,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "contributionHash": "sha256-62290db47bb715a394703feface42956bd76762cc46e41871be2d4c6088926f8"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 11.2,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "contributionHash": "sha256-2c261a74b574903f533b54dbb876ed54b89344637cb324d566afd587e6fb1ec9"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 10.74,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "contributionHash": "sha256-4d1eb074e43d03e1bb3481de720554475dcffbd6811c616684e790a98fc50a62"
        }
      ],
      "topEvidenceGaps": [
        {
          "id": "gap-runtime-orekit-propagation-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
        },
        {
          "id": "gap-runtime-gmat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
        },
        {
          "id": "gap-runtime-tudat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
        },
        {
          "id": "gap-materials-process-oxygen-isru",
          "category": "materials-process",
          "priorityLane": "P1-business-grade",
          "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
        }
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for asteroid-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion.",
        "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
        "resource-evidence: Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Customer-facing use remains blocked until source-use review approves cited sources.",
        "3 runtime sidecar contract(s) still block mission-design promotion."
      ],
      "nextProofActions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
      },
      "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
    },
    {
      "id": "customer-dossier-mercury-orbit",
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "rank": 4,
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "customerUseState": "research-backlog-only",
      "commercialUseAllowed": false,
      "buyerUseBoundary": "Use only as research backlog intelligence until scenario evidence, runtime validation, and source-use gates improve.",
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "summary": "Maximum long-term energy/vacuum upside, high logistics and autonomy burden.",
      "metrics": {
        "deterministicUtility": 42.95,
        "decisionReadinessScore": 44.15,
        "utilityP10": 39.63,
        "utilityMedian": 42.76,
        "utilityP90": 46.47,
        "winProbability": 0,
        "uncertaintyBudgetPoints": 65.61,
        "uncertaintyClass": "high-uncertainty",
        "businessReadinessMedian": 55.33,
        "medianCapitalGapBn": 0
      },
      "evidenceState": {
        "supportingClaimCount": 3,
        "blockedClaimCount": 3,
        "sourceUseCustomerAllowed": false,
        "promotedRuntimeContracts": 2,
        "readyRuntimeContracts": 0,
        "blockedRuntimeContracts": 3,
        "modelRunComparisonCount": 2,
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "supportingClaims": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
        }
      ],
      "blockedClaims": [
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "blockerCount": 2,
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "blockerCount": 3,
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "blockerCount": 3,
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
        }
      ],
      "runRefs": [],
      "modelRunComparisons": [
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ],
      "proofToChangeAnswer": {
        "crossoverId": "crossover-mercury-orbit-over-moon-first",
        "challengerScenarioId": "mercury-orbit",
        "currentLeaderScenarioId": "moon-first",
        "requiredUtilityDelta": 24.17,
        "crossoverState": "outside-single-lever-range",
        "topLeverPaths": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "currentValue": 24,
            "direction": "decrease",
            "utilityPerPoint": 0.42,
            "requiredRawDelta": 57.55,
            "feasibleByRawRange": false,
            "headroom": 24
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "currentValue": 86,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 175.43,
            "feasibleByRawRange": false,
            "headroom": 86
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "currentValue": 70,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 175.43,
            "feasibleByRawRange": false,
            "headroom": 70
          }
        ],
        "crossoverHash": "sha256-f940f38796bd99b5bea066e98097804da86a30d687c323e182571126dc7f0531"
      },
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 16,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 11.82,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "contributionHash": "sha256-c7a1e79ea5ee80f6e71b08dd891825dc28d5ad7f6a6250d69309b5965aa8aff6"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 11,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "contributionHash": "sha256-d23405c06a904d5d1e4f33ec35240bb179a08e65ed69c7c42149c071a8824cf7"
        }
      ],
      "topEvidenceGaps": [
        {
          "id": "gap-runtime-orekit-propagation-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
        },
        {
          "id": "gap-runtime-gmat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
        },
        {
          "id": "gap-runtime-tudat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
        },
        {
          "id": "gap-materials-process-oxygen-isru",
          "category": "materials-process",
          "priorityLane": "P1-business-grade",
          "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
        }
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mercury-orbit: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
        "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
        "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "resource-evidence: Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Customer-facing use remains blocked until source-use review approves cited sources.",
        "3 runtime sidecar contract(s) still block mission-design promotion."
      ],
      "nextProofActions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
      },
      "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
    },
    {
      "id": "customer-dossier-mars-first",
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "rank": 5,
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "customerUseState": "research-backlog-only",
      "commercialUseAllowed": false,
      "buyerUseBoundary": "Use only as research backlog intelligence until scenario evidence, runtime validation, and source-use gates improve.",
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "summary": "Strong exploration ecosystem, weak for first industrial-capacity maximization.",
      "metrics": {
        "deterministicUtility": 40.78,
        "decisionReadinessScore": 41.72,
        "utilityP10": 38.47,
        "utilityMedian": 40.76,
        "utilityP90": 42.8,
        "winProbability": 0,
        "uncertaintyBudgetPoints": 44.69,
        "uncertaintyClass": "medium-uncertainty",
        "businessReadinessMedian": 63.22,
        "medianCapitalGapBn": 0
      },
      "evidenceState": {
        "supportingClaimCount": 3,
        "blockedClaimCount": 3,
        "sourceUseCustomerAllowed": false,
        "promotedRuntimeContracts": 2,
        "readyRuntimeContracts": 0,
        "blockedRuntimeContracts": 3,
        "modelRunComparisonCount": 2,
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "supportingClaims": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
        }
      ],
      "blockedClaims": [
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "blockerCount": 2,
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "blockerCount": 3,
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "blockerCount": 3,
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
        }
      ],
      "runRefs": [],
      "modelRunComparisons": [
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ],
      "proofToChangeAnswer": {
        "crossoverId": "crossover-mars-first-over-moon-first",
        "challengerScenarioId": "mars-first",
        "currentLeaderScenarioId": "moon-first",
        "requiredUtilityDelta": 26.34,
        "crossoverState": "outside-single-lever-range",
        "topLeverPaths": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "currentValue": 12,
            "direction": "decrease",
            "utilityPerPoint": 0.42,
            "requiredRawDelta": 62.71,
            "feasibleByRawRange": false,
            "headroom": 12
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "currentValue": 62,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 191.18,
            "feasibleByRawRange": false,
            "headroom": 62
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "currentValue": 48,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 191.18,
            "feasibleByRawRange": false,
            "headroom": 48
          }
        ],
        "crossoverHash": "sha256-10c3e7b172c2d8ee3f3d88aea2ae3824e3325b1901205a9de783e5f4b62c146a"
      },
      "topUncertaintyDrivers": [
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 10.99,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "contributionHash": "sha256-73b99d87c128271af6a24e0fae56a71454d5ace353dec7ee58a332eeb04b00dc"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 7.16,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "contributionHash": "sha256-6d5f5c1fdf60a3c4743279885720f52b7f46f0ffa8c83022379740cce7fad390"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        }
      ],
      "topEvidenceGaps": [
        {
          "id": "gap-runtime-orekit-propagation-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
        },
        {
          "id": "gap-runtime-gmat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
        },
        {
          "id": "gap-runtime-tudat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
        },
        {
          "id": "gap-materials-process-oxygen-isru",
          "category": "materials-process",
          "priorityLane": "P1-business-grade",
          "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
        }
      ],
      "blockers": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
        "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "source-use-rights: Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Customer-facing use remains blocked until source-use review approves cited sources.",
        "3 runtime sidecar contract(s) still block mission-design promotion."
      ],
      "nextProofActions": [
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
      },
      "dossierHash": "sha256-9b2f28af62986d0203a5ba94c61ec789c654956fed4f4ca9143cec9ddd891912"
    },
    {
      "id": "customer-dossier-mercury-polar",
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "rank": 6,
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "customerUseState": "research-backlog-only",
      "commercialUseAllowed": false,
      "buyerUseBoundary": "Use only as research backlog intelligence until scenario evidence, runtime validation, and source-use gates improve.",
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "summary": "Polar volatile access is attractive, but surface thermal/comms risk is severe.",
      "metrics": {
        "deterministicUtility": 37.95,
        "decisionReadinessScore": 41.42,
        "utilityP10": 34.02,
        "utilityMedian": 37.73,
        "utilityP90": 41.65,
        "winProbability": 0,
        "uncertaintyBudgetPoints": 64.95,
        "uncertaintyClass": "high-uncertainty",
        "businessReadinessMedian": 53.68,
        "medianCapitalGapBn": 0
      },
      "evidenceState": {
        "supportingClaimCount": 3,
        "blockedClaimCount": 3,
        "sourceUseCustomerAllowed": false,
        "promotedRuntimeContracts": 2,
        "readyRuntimeContracts": 0,
        "blockedRuntimeContracts": 3,
        "modelRunComparisonCount": 2,
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "supportingClaims": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
        }
      ],
      "blockedClaims": [
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "blockerCount": 2,
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "blockerCount": 3,
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "blockerCount": 3,
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
        }
      ],
      "runRefs": [],
      "modelRunComparisons": [
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ],
      "proofToChangeAnswer": {
        "crossoverId": "crossover-mercury-polar-over-moon-first",
        "challengerScenarioId": "mercury-polar",
        "currentLeaderScenarioId": "moon-first",
        "requiredUtilityDelta": 29.17,
        "crossoverState": "outside-single-lever-range",
        "topLeverPaths": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "currentValue": 26,
            "direction": "decrease",
            "utilityPerPoint": 0.42,
            "requiredRawDelta": 69.45,
            "feasibleByRawRange": false,
            "headroom": 26
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "currentValue": 90,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 211.72,
            "feasibleByRawRange": false,
            "headroom": 90
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "currentValue": 64,
            "direction": "decrease",
            "utilityPerPoint": 0.1378,
            "requiredRawDelta": 211.72,
            "feasibleByRawRange": false,
            "headroom": 64
          }
        ],
        "crossoverHash": "sha256-0919818abda3f7c04f8c359aef7aeceb89e09cf8edaff76dceaa60fe8d08423b"
      },
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 16,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 12.18,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "contributionHash": "sha256-3b063b187963ef7fdcff3cab7471cc8248af9a172602d565ae776b10366e99cc"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 10.4,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "contributionHash": "sha256-9e4d02974fb4ab05d2fb6acbadc7d88c08f2d052378c2f7f7e5bc448f8e84f95"
        }
      ],
      "topEvidenceGaps": [
        {
          "id": "gap-runtime-orekit-propagation-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
        },
        {
          "id": "gap-runtime-gmat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
        },
        {
          "id": "gap-runtime-tudat-transfer-v1",
          "category": "runtime-sidecar",
          "priorityLane": "P0-critical-path",
          "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
        },
        {
          "id": "gap-materials-process-oxygen-isru",
          "category": "materials-process",
          "priorityLane": "P1-business-grade",
          "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
        }
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mercury-polar: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
        "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
        "resource-evidence: Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Customer-facing use remains blocked until source-use review approves cited sources.",
        "3 runtime sidecar contract(s) still block mission-design promotion."
      ],
      "nextProofActions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
      },
      "dossierHash": "sha256-a001cc9b3fcd2145c24f0c13591c7208b40f9add849b887e6b8219d8208e08a2"
    }
  ],
  "ledgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669"
}
;
